import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import Modal_Vehiculos from './modal_vehiculos';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';
import Select from 'react-select';
import copyright from '../../img/copyright-gray.png';
import {sendLog} from '../../util'


import './modal.css';


const database = firebase.database();



const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	  
	}
  };


class Vehiculos extends Component{

	
	constructor(props){
		
		super(props);
		this.state={
			socios:[],
			bases:[],
			isActiveSocios:false,
			isActiveBases:false,
			vehiculos:[],
			isActive:false,
			keyRow:'',
			anio:'',
			capacidad:'',
			codigo_socio:'',
			disponibilidad:'',
			estado:'',
			foto:'',
			tipo:'',
			marca:'',
			movil:'',
			modelo:'',
			placa:'',
			base:'',
			nombreSocio:'',
			uploadValue:0,
			files:null,
			nodoBase:'',
			nombreBase:'',
			tipos:[],
			template:false,
			empresas:[],
			empresaL:[],
			empresasV:[]
				
			
		}
		
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.sociosRef=database.ref().child('Socios');
		this.basesRef=database.ref().child('Bases');
		this.handleClickSocios=this.handleClickSocios.bind(this);
		this.handleUpload=this.handleUpload.bind(this);
		this.sociosRef=database.ref().child('Socios');
		this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		this.handleClickBases=this.handleClickBases.bind(this);
		this.btnBasesFormatter=this.btnBasesFormatter.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.updateRow=this.updateRow.bind(this);
		this.makeOptions=this.makeOptions.bind(this);
		
		this.tiposVehiculos=database.ref().child('Tipos_Vehiculos');	

		
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}

	}
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	handleClickClose(){		
		this.updateRow();		
	}
	
	
	


	
	componentDidMount() {
		try
		{
			this.tiposVehiculos.once('value',this.gotDataTipos,this.errDataTipos);
			this.basesRef.once('value',this.gotDataBases,this.errDataBases);
			this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);
			this.vehiculosRef.on('value', this.gotData, this.errData);
			Modal.setAppElement('body');
		}
		catch(e){
			console.log(e)
		}
		this.getEmpresas();
		this.checkSAdmin();
	}

	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				let data = element.val();
				data.key = element.key;
				if (data.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}

	getEmpresas = () => {

		let empresas = []
		firebase.database().ref('Empresa').once('value').then(snap => {
			snap.forEach( element => {
				let empresa = element.val();
				empresa.key = element.key;
				// console.log(empresa.key);
				empresas.push({value:empresa.key, label:empresa.codigo_empresa});
				// console.log(empresas);
			})
			this.setState({empresas})
		});

	}
	
	
	gotDataTipos=(data)=>{
		
		
		let newTipos=[]
		
		
		if(data.val()!==null){
			
			
			let tipos=data.val();
			let keys=Object.keys(tipos);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				
				
						
					newTipos.push({
						tipo:tipos[k].tipo,
						estado:tipos[k].estado
					})
					
					
				
				
			}
			this.setState({tipos:newTipos})
			
			
			
		}
		
	}
	errDataTipos=(err)=>{
		
		console.log(err);
		
	}
	
	
	
	
	gotDataBases = (data) => {
		
		
		  let newBase = [];
		  const basedata = data.val();
		  if(data.val()!==null){
			const keys = Object.keys(basedata);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newBase.push({
				key:k,
				nombre:basedata[k].Nombre,
				descripcion:basedata[k].Descripcion,
				foto:basedata[k].foto,
				latitud:basedata[k].latitud,
				longitud:basedata[k].longitud,
				direccion:basedata[k].direccion
				});
			}
			this.setState({bases: newBase});
			}
		}
		errDataBases = (err) => {
			console.log(err);
		}
	
	
	gotDataSocios=(data) =>{
		let newsocios = []
		const sociosdata = data.val();
		if(data.val()!==null){
			const keys = Object.keys(sociosdata);

			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
		
		
				
				newsocios.push({
					key:k,
					nombre:sociosdata[k].Nombre,
					apellido:sociosdata[k].Apellido,
					estado:sociosdata[k].Estado

					});
					
		
				
			}
			this.setState({socios: newsocios});
		}
	}
	errDataSocios = (err)=>{
		
		console.log(err);
		
	}
	
	verificarViaje = async (key) => {
		const snap = await firebase.database().ref().child('ProgramacionDia').child(key).child('estado').once('value');
		const data = snap.val();

		return data;
	}
	
	//get the data from the firebase and push them out
	gotData = async (data) => {
		
		  let nombre_socio='';
		  let nombre_base='';
		  let newVehiculo = [];
		 
		  if(data.val()!==null){
			const vehiculodata = data.val();
		  const keys = Object.keys(vehiculodata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];


			for (let j = 0; j < this.state.socios.length; j++) {

				if (this.state.socios[j].key === vehiculodata[k].codigo_socio) {
					nombre_socio = this.state.socios[j].nombre + ' ' + this.state.socios[j].apellido;
				}
			}

			for (let j = 0; j < this.state.bases.length; j++) {
				if (this.state.bases[j].key === vehiculodata[k].base) {
					nombre_base = this.state.bases[j].nombre;
				}
			}

			if (vehiculodata[k].marca !== undefined) {
				const data = {
					key: k,
					anio: vehiculodata[k].anio,
					capacidad: vehiculodata[k].capacidad,
					codigo_socio: vehiculodata[k].codigo_socio,
					disponibilidad: vehiculodata[k].disponibilidad,
					estado: vehiculodata[k].estado,
					foto: vehiculodata[k].foto,
					marca: vehiculodata[k].marca,
					modelo: vehiculodata[k].modelo,
					placa: vehiculodata[k].placa,
					tipo: vehiculodata[k].tipo_vehiculo,
					base: vehiculodata[k].base,
					nombreSocio: nombre_socio,
					nombreBase: nombre_base,
					movil: vehiculodata[k].movil,
					empresas: vehiculodata[k].empresas,
					viajeAsignado: vehiculodata[k].viajeAsignado,
					estadoViaje: '',
				}

				if (vehiculodata[k].viajeAsignado)
					data.estadoViaje = await this.verificarViaje(vehiculodata[k].viajeAsignado);

				newVehiculo.push(data);
			}


		}
		  this.setState({vehiculos: newVehiculo});
		}
		}
		errData = (err) => {
	      console.log(err);
	    }
	
	handleClick = (rowKey) => {

		let empresaV = [];
		if (rowKey.empresas !== undefined && rowKey.empresas !== '') {
			let empresas = rowKey.empresas;
			empresas.forEach( element => {
				empresaV.push({value:element});
			})
		}
		this.changeEmpresa(empresaV)
		this.setState({
		   keyRow:rowKey.key,
		   anio:rowKey.anio,
		   capacidad:rowKey.capacidad,
		   codigo_socio:rowKey.codigo_socio,
		   disponibilidad:rowKey.disponibilidad,
		   estado:rowKey.estado,
		   foto:rowKey.foto,
		   marca:rowKey.marca,
		   modelo:rowKey.modelo,
		   placa:rowKey.placa,
		   tipo:rowKey.tipo,
		   nombreSocio:rowKey.nombreSocio,
		   base:rowKey.base,
		   nodoBase:rowKey.base,
		   nombreBase:rowKey.nombreBase,
		   movil:rowKey.movil
		});
		
		this.toggleModalUpdate();
	}
	
	handleClickLiberar = (rowKey) => {
		this.vehiculosRef.child(rowKey.key).update({
			estado: 'Disponible',
			viajeAsignado: false
		});
	

		Alert.success('Datos actualizados correctamente', {
			effect: 'genie',
			position: 'bottom-right',
			timeout: 2000
		});
		sendLog({ tipo: 'vehiculo_liberado', informacion_extra: { vehiculo: rowKey.key } });
	}
	
	toggleModalUpdate=()=>{
		
		this.setState({
			uploadValue:0,
			isActive:!this.state.isActive,			
		})		
		
		
	}
	
	updateRow=()=>{
		let {empresaL} = this.state;
		let nodoHijo=this.keyRow.value;
		let empresas = [];
		//Archivo de la imagen
		let archivo=this.state.files;
		empresaL.forEach( element => {
			empresas.push(element.value);
		})
		
		let tipoVehiculo=this.tipoVehiculo.value;
		if (empresaL.length > 0) {
			
			if(archivo===null){
					
				this.vehiculosRef.child(nodoHijo).update({
				   
				   capacidad:this.capacidadVehiculo.value,
				   marca:this.marcaVehiculo.value,
				   modelo:this.modeloVehiculo.value,
				   placa:this.placaVehiculo.value,
				   estado:this.estadoVehiculo.value,
				   tipo_vehiculo:this.tipoVehiculo.value,
				   codigo_socio:this.socioKey.value,
				   anio:this.anioVehiculo.value,
				   base:this.state.nodoBase,
				   movil:this.movilVehiculo.value,
				   empresas
					
				});
				
				
				database.ref().child('Empleados').orderByChild('vehiculo').equalTo(nodoHijo).once("value").then((snapshot)=>{
					
					if(snapshot.exists()){
						
						database.ref().child('Empleados').orderByChild('vehiculo').equalTo(nodoHijo).once('value',(snapshot)=>{
							
							
							if(snapshot.val()!==null){
									
									let dataempleados=snapshot.val();
									let keys=Object.keys(dataempleados);
									
									for(let i=0;i<keys.length;i++){
										
										let k=keys[i];									
										
										database.ref().child('Empleados').child(k).update({
																					
											tipo_vehiculo:tipoVehiculo
										})
										
									}
								
							}
							
						})
					
					}
					
				})
				
				
				
				//database.ref().child('Empleados').orderByChild('vehiculo').equalTo()
				
				
				Alert.success('Datos actualizados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000
				});
				sendLog({tipo: 'vehiculo_editado', informacion_extra: {vehiculo: nodoHijo}})
				this.toggleModalUpdate();
				
			}
			else
			{
				
				const storageRef = firebase.storage().ref(`Vehiculos/${archivo.name}`);
			
				const task= storageRef.put(archivo);
			
				task.on('state_changed', snapshot =>{
			
			
					this.setState({
					  uploadValue :50,
					})
	
					}, error =>{ console.log(error.message);
					},
					async ()=>{
						const url = await task.snapshot.ref.getDownloadURL();
						
	
						this.vehiculosRef.child(nodoHijo).update({
				   
						   capacidad:this.capacidadVehiculo.value,
						   marca:this.marcaVehiculo.value,
						   modelo:this.modeloVehiculo.value,
						   placa:this.placaVehiculo.value,
						   estado:this.estadoVehiculo.value,
						   tipo_vehiculo:this.tipoVehiculo.value,
						   codigo_socio:this.socioKey.value,
						   anio:this.anioVehiculo.value,
						   foto:url,
						   base:this.state.nodoBase
					
						});
				
	
						
						this.setState({
							uploadValue:100,
							urlFoto:task.snapshot.getDownloadURL
							
						});
	
				
						this.toggleModalUpdate();
						
						
						Alert.success('Datos guardados correctamente', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000
							
						});
						 
	
				});		
			}
		} else {
			Alert.warning('Datos imcompletos, ingrese una o mas empresas para vehiculo', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:3000
				
			});
		}
				
		
		
		
	}

	changeEmpresa = (event) => {
		let empresaL = []
		let {empresas} = this.state;
		let findEmpresas;

		if (event.label !== undefined) {
			event.forEach( element => {
			
				empresaL.push(element.value);
			})
			this.setState({empresaL});
		} else {
			
			event.forEach( element => {
				findEmpresas = empresas.find(efind => {
					return efind.value === element.value;
				})
				empresaL.push(findEmpresas);
			})		
			this.setState({empresaL});
		}
		

	}
 
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Modificar</button>;
	}
 
	liberarViaje(cell, row) {
		return row.viajeAsignado && row.estadoViaje==='Finalizado' || row.estadoViaje==='Cancelado' ? <button className="btn btn-danger btn-sm" onClick={() => { this.handleClickLiberar(row) }} >Liberar</button> : '';
	}
 
	toggleModalSocios=()=>{
		this.setState({
			
			isActiveSocios:!this.state.isActiveSocios
			
		})			
	}
	
	toggleModalBases=()=>{
		
		this.setState({
			
				isActiveBases:!this.state.isActiveBases
			
		})
		
		
	}
 
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		
				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);			
		}
	}
	
	
	handleClickSocios=(rowKey)=>{
		
		this.setState({
			isActiveSocios:!this.state.isActiveSocios
		})
		
		this.socioKey.value=rowKey.key;
		this.socioVehiculo.value=rowKey.nombre+' '+rowKey.apellido; 
		
	}
	
	btnSoiciosFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickSocios(row)}} >Seleccionar</button>;
	}
	
	
	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}
	
	handleKeyPressNumeros(e){
	
		
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}
 
	handleClickBases=(rowKey)=>{
		
		
		this.state.nombreBase=rowKey.nombre;
		this.state.nodoBase=rowKey.key;
		
		this.toggleModalBases();
		
	}
 
 
	btnBasesFormatter(cell,row){
		
		
		return <button className="btn btn-success btn-sm" onClick={() => {this.handleClickBases(row)}} >Seleccionar</button>;
	}
 
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
 
	makeOptions(x){
		
		return <option key={'tipo '+x.tipo}>{x.tipo}</option>
		
		
	}
	
	render(){
		
		let {empresas, empresaL} = this.state;
		let {checkAdmin} = this.state;

		return(
		
			<div className="Vehiculos container" onClick={this.ocultarMenu}>	
			<Modal_Vehiculos/>
			
			
			
			{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
			

			<BootstrapTable data={ this.state.vehiculos }
				 ref='table'			 
				 pagination={ true }
				 search={ true }
				 hover
				 >
				 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
				 <TableHeaderColumn dataField='movil' dataAlign='center' dataSort={true}>Unidad</TableHeaderColumn>
				 <TableHeaderColumn dataField='marca' dataSort={true}>Marca</TableHeaderColumn>
				 <TableHeaderColumn dataField='modelo' dataSort={true}>Modelo</TableHeaderColumn>
				 <TableHeaderColumn dataField='placa'>Placa</TableHeaderColumn>
				 <TableHeaderColumn dataField='capacidad' >Capacidad</TableHeaderColumn>
				 <TableHeaderColumn dataField='anio' >Año</TableHeaderColumn>
				 <TableHeaderColumn dataField='nombreSocio' >Socio</TableHeaderColumn>
				 <TableHeaderColumn dataField='estado' dataSort={true} >Estado</TableHeaderColumn>
				 <TableHeaderColumn dataField='empresas' hidden>Empresas</TableHeaderColumn>
				 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.liberarViaje.bind(this)} dataSort={true}>Liberar</TableHeaderColumn>
				 {checkAdmin &&
				 	<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
				 }
			  </BootstrapTable>
					
			  <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
						
						
							<h3>Modificar Vehiculo</h3>
							<hr/>
							<input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
								
								<div className="form-group">
									<label htmlFor="movil" >Unidad:</label>
									<input 	type="text" className="form-control" name="movil" 
										ref={input => {this.movilVehiculo=input;}}
										required autoComplete="off"
										placeholder="movil"
										defaultValue={this.state.movil}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="marca" >Marca:</label>
									<input 	type="text" className="form-control" name="marca" 
										ref={input => {this.marcaVehiculo=input;}}
										required autoComplete="off"
										placeholder="Marca"
										onKeyPress={this.handleKeyPressLetras}
									defaultValue={this.state.marca}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="modelo" >Modelo:</label>
									<input type="text" className="form-control" name="modelo" 
										ref={input => {this.modeloVehiculo=input;}}
										required autocomplete="off"
										placeholder="Modelo"
									defaultValue={this.state.modelo}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="anio">Año</label>
									<input type="text" className="form-control" name="anio"
									ref={input => {this.anioVehiculo=input;}}
									placeholder="Año" required autocomplete="off"
									defaultValue={this.state.anio}
									minLength="4" maxLength="4"
									onKeyPress={this.handleKeyPressNumeros}
									/>
									
								</div>
								<div className="form-group">
									<label htmlFor="placa" >Placa:</label>
									<input type="text" className="form-control" name="placa" 
										ref={input => {this.placaVehiculo=input;}}
										required autocomplete="off" 
										placeholder="Placa"
									defaultValue={this.state.placa}
									/>
								</div>
								<div className="form-group">
									<label  htmlFor="telefono" >Capacidad:</label>
									<input type="text" className="form-control" name="capacidad"
										ref={input => {this.capacidadVehiculo=input;}}
										onKeyPress={this.handleKeyPressNumeros}
										required autocomplete="off"
										placeholder="Telefono"
										maxLength="2" 
										
									defaultValue={this.state.capacidad}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="disponibilidad">Estado</label>
									<select className="form-control" 
										ref={input => {this.estadoVehiculo=input;}}
										defaultValue={this.state.estado}
									>
									<option value="Disponible">Disponible</option>
									<option value="Asignado">Asignado</option>
									<option value="Inactivo">Inactivo</option>
									
									</select>
								</div>
								<div className="form-group">
									<label htmlFor="tipo_vehiculo">Tipo de vehiculo</label>
									<select name="tipo_vehiculo" className="form-control"
									ref={input => {this.tipoVehiculo=input;}}
									defaultValue={this.state.tipo}
									>
										{this.state.tipos.map(this.makeOptions)}
									</select>
								</div>
								
								<div className="form-group">
									<label htmlFor="socio">Socios</label>
									<input type="text" className="form-control"
									ref={input => {this.socioVehiculo=input;}}
									readOnly="readonly" required autoComplete="off"
									onClick={this.toggleModalSocios}
									placeholder="Elige un socio"
									defaultValue={this.state.nombreSocio}
									/>
									<input type="text" name="keySocio"  className="id"
									ref={input =>{this.socioKey=input;}} defaultValue={this.state.codigo_socio}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="base">Base</label>
									<input type="text" className="form-control" 
									ref={input => {this.baseVehiculo=input;}}
									readOnly="readonly" required autoComplete="off"
									onClick={this.toggleModalBases}
									placeholder="Ejile una base"
									value={this.state.nombreBase}									
									/>
								</div>

								<div className="form-group">
									<label htmlFor="socio">Empresas</label>
									<Select value={empresaL} onChange={this.changeEmpresa} options={empresas} isMulti />
								</div>

								<div className="form-group">
										<label htmlFor="foto">Foto del vehiculo</label>
										<br/>
										<progress value={this.state.uploadValue} max="100"></progress>
										<input type="file" className="form-control"  onChange={this.handleUpload}/>
								</div>
								<img src={this.state.foto} alt="Foto vehiculo" className="foto" width="240px"/>
							<hr/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
						
						
					</Modal> 
		
						<Modal isOpen={this.state.isActiveSocios} onRequestClose={this.toggleModalSocios}  style={customStyles}>
						<h4>Selecciona un socio</h4>
						<hr/>
					
						<BootstrapTable data={ this.state.socios}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnSoiciosFormatter.bind(this) }>Editar</TableHeaderColumn>
						</BootstrapTable>
					
					</Modal>
					
					
					<Modal isOpen={this.state.isActiveBases} onRequestClose={this.toggleModalBases} style={customStyles}>
						<h4>Selecciona una base</h4>
						<hr/>
						<BootstrapTable data={ this.state.bases}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>						
							 <TableHeaderColumn dataField='direccion' dataSort={true}  >Direccion</TableHeaderColumn>							 
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnBasesFormatter.bind(this) }>Seleccionar</TableHeaderColumn>
						</BootstrapTable>
						
						
					</Modal>
				<footer class="footer-pg mt-auto py-3" style={{width:'100%'}}>
				<div class="container">
					<div class="row">
						<div className="col-md-4 col-sm-4">
						</div>
						<div class="col-sm">
							<img src={copyright}/>
						</div>
					</div>
				</div>
				</footer>
			</div>
			
		);
		
		
	}
	
	
}


export default Vehiculos;


// WEBPACK FOOTER //
// ./src/Components/Vehiculos/Vehiculos.jsx